import { TypographyFontSize, TypographyFontFamily } from '@design-system/components/atoms/typography/entities/typography.types';

export enum ChipActionStatus {
  Default = 'default',
  Selected = 'selected',
}

export enum ChipActionType {
  Compact = 'compact',
  Long = 'long'
}

export enum ChipActionSizes {
  XL = 'xl',
  LG = 'lg',
  MD = 'md',
  RG = 'rg',
}

export enum ChipActionBranding {
  Civitatis = 'civitatis',
  Marriott = 'marriott',
  None = 'none',
}

interface DeviceProps {
  Height: string;
  Width: string;
  FontFamily: TypographyFontFamily;
  FontSize: TypographyFontSize;
  IconSize: number;
  LoaderSize: string;
}
export interface ChipActionSizeConfigProps {
  [ChipActionType.Compact]: DeviceProps;
  [ChipActionType.Long]: DeviceProps;
}

export const ChipActionSizeConfig: { [key: string]: ChipActionSizeConfigProps } = {
  [ChipActionSizes.XL]: {
    [ChipActionType.Compact]: {
      Height: '80px',
      Width: '80px',
      FontFamily: TypographyFontFamily.Regular,
      FontSize: TypographyFontSize.XXS,
      IconSize: 36,
      LoaderSize: '24px',
    },
    [ChipActionType.Long]: {
      Height: 'auto',
      Width: '25px',
      FontFamily: TypographyFontFamily.SemiBold,
      FontSize: TypographyFontSize.XXS,
      IconSize: 24,
      LoaderSize: '16px',
    },
  },
  [ChipActionSizes.LG]: {
    [ChipActionType.Compact]: {
      Height: '72px',
      Width: '72px',
      FontFamily: TypographyFontFamily.Regular,
      FontSize: TypographyFontSize.XXXS,
      IconSize: 30,
      LoaderSize: '20px',
    },
    [ChipActionType.Long]: {
      Height: 'auto',
      Width: '25px',
      FontFamily: TypographyFontFamily.SemiBold,
      FontSize: TypographyFontSize.XXS,
      IconSize: 24,
      LoaderSize: '16px',
    }
  },
  [ChipActionSizes.MD]: {
    [ChipActionType.Compact]: {
      Height: '64px',
      Width: '64px',
      FontFamily: TypographyFontFamily.Regular,
      FontSize: TypographyFontSize.XXXS,
      IconSize: 24,
      LoaderSize: '18px',
    },
    [ChipActionType.Long]: {
      Height: 'auto',
      Width: '25px',
      FontFamily: TypographyFontFamily.SemiBold,
      FontSize: TypographyFontSize.XXS,
      IconSize: 24,
      LoaderSize: '16px',
    }
  },
  [ChipActionSizes.RG]: {
    [ChipActionType.Compact]: {
      Height: '56px',
      Width: '56px',
      FontFamily: TypographyFontFamily.Regular,
      FontSize: TypographyFontSize.XXXS,
      IconSize: 20,
      LoaderSize: '16px',
    },
    [ChipActionType.Long]: {
      Height: 'auto',
      Width: '25px',
      FontFamily: TypographyFontFamily.SemiBold,
      FontSize: TypographyFontSize.XXS,
      IconSize: 24,
      LoaderSize: '16px',
    }
  },
};
